import React from 'react';
import './Welcome.css';
import { Typography } from '@mui/material';

function Welcome() {
  return (
    <div id="welcome" className="main ">
      <Typography variant="h1"> This is the Welcome section </Typography>
    </div>
  );
}

export default Welcome;
